import { Button } from "@mui/material";
import clsx from "clsx";
import { useTranslations } from "use-intl";

import {
  IconLuggageNotSelected,
  IconLuggageSelected,
} from "@/components/Icons";
import type { GetFlightAvailabilityTokenOptionsPrice } from "@/types/codegen";
import { formatCurrency } from "@/utils/currency";

type Props = {
  label: string;
  price: GetFlightAvailabilityTokenOptionsPrice;
  selected: boolean;
  onClick: () => void;
};

export const BaggageOptionCard = ({
  label,
  price,
  selected,
  onClick,
}: Props) => {
  const t = useTranslations();
  const BaggageIcon = selected ? IconLuggageSelected : IconLuggageNotSelected;

  return (
    <div
      className={clsx(
        "flex items-start justify-between gap-3 rounded-2xl border bg-white p-3",
        {
          "border-stroke-neutral-soft": !selected,
          "border-core-accent-500": selected,
        },
      )}
    >
      <div className="flex gap-1">
        <BaggageIcon className="size-6 shrink-0" />
        <div className="flex flex-col gap-1 text-text-primary">
          <div className="font-medium">{label}</div>
          {price.amount !== null ? (
            <div className="text-sm font-semibold">
              {formatCurrency(price.amount, price.currency || undefined)}
            </div>
          ) : null}
        </div>
      </div>
      <Button
        variant="outlined"
        size="small"
        color={selected ? "error" : "primary"}
        onClick={onClick}
        sx={{
          minWidth: "69px",
        }}
      >
        {selected ? t("remove") : t("add")}
      </Button>
    </div>
  );
};
